__turbopack_context__.v({
  "fadeInItems": "Portfolio-module__txoJ0a__fadeInItems",
  "image": "Portfolio-module__txoJ0a__image",
  "imageRatio": "Portfolio-module__txoJ0a__imageRatio",
  "imageResized": "Portfolio-module__txoJ0a__imageResized",
  "imageWrapper": "Portfolio-module__txoJ0a__imageWrapper",
  "imageWrapperLandscape": "Portfolio-module__txoJ0a__imageWrapperLandscape",
  "row": "Portfolio-module__txoJ0a__row",
  "spacing--lg": "Portfolio-module__txoJ0a__spacing--lg",
  "spacing--md": "Portfolio-module__txoJ0a__spacing--md",
  "spacing--sm": "Portfolio-module__txoJ0a__spacing--sm",
  "spacing--xl": "Portfolio-module__txoJ0a__spacing--xl",
  "spacing--xs": "Portfolio-module__txoJ0a__spacing--xs",
  "spacing--xxl": "Portfolio-module__txoJ0a__spacing--xxl",
  "spacing--xxs": "Portfolio-module__txoJ0a__spacing--xxs",
  "spacing--xxxl": "Portfolio-module__txoJ0a__spacing--xxxl",
  "spacing--xxxs": "Portfolio-module__txoJ0a__spacing--xxxs",
});
